import type { FloorLayout } from './types'

interface Props {
  floors: FloorLayout[]
  currentFloorId: string | null
  onSelect: (floorId: string) => void
  onClose: () => void
}

export default function FloorSelectModal({ floors, currentFloorId, onSelect, onClose }: Props) {
  return (
    <div className="mall-modal-overlay" onClick={onClose}>
      <div className="mall-modal" onClick={(e) => e.stopPropagation()}>
        <div className="mall-modal-header">
          <span>Store directory</span>
          <button className="mall-modal-close" onClick={onClose} aria-label="Close">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>
        <div className="mall-modal-list">
          {floors.map((floor) => (
            <button
              key={floor.id}
              className={`mall-floor-row${floor.id === currentFloorId ? ' mall-floor-row--active' : ''}`}
              style={{ ['--floor-color' as string]: floor.color, ['--floor-rgb' as string]: floor.rgb }}
              onClick={() => { onSelect(floor.id); onClose() }}
            >
              <span className="mall-floor-swatch" />
              <span className="mall-floor-name">{floor.category}</span>
              <span className="mall-floor-count">{floor.shopCount} shop{floor.shopCount !== 1 ? 's' : ''}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
